import React from "react";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { local } from "../../internationalization/Localization";
import { S } from "../../auth/sdk";

export interface ConfirmationInputFormProps {
  title: string;
  text: string;
  continueText: string;
  cancelText: string;
  resolve: (value: any | PromiseLike<any>) => void;
}

export const ConfirmationInputForm: React.FunctionComponent<ConfirmationInputFormProps> = (props) => {
  const onContinueButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve(S.ConfirmationInput.create(0));
  }
  const onCancelButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve(S.ConfirmationInput.create(1));
  }

  return (
    <form className="ConfirmationInputForm">
      <h1 className="App_pageTitle">{props.title}</h1>
      <p className="App_formDesc">{props.text}</p>
      <div className={"App_formButtonGroup"}>
        <Button
          variant={ButtonVariant.secondary}
          type="button"
          onClick={onCancelButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
          {local.get("buttonLabels[0]")}
        </Button>
        <Button
          variant={ButtonVariant.primary}
          type="submit"
          onClick={onContinueButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
          {local.get("buttonLabels[1]")}
        </Button>
      </div>
    </form>
  );
}
